export default "__VITE_ASSET__DgZr6THN__"